import { render, staticRenderFns } from "./AreaRefine.vue?vue&type=template&id=4df87062"
import script from "./AreaRefine.vue?vue&type=script&lang=js"
export * from "./AreaRefine.vue?vue&type=script&lang=js"
import style0 from "./AreaRefine.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports